export const MORTGAGE_MINI_CALCULATOR_MF_NAME = 'mortgage-mini-calculator';
